import { Link } from "react-router-dom";
import { Wrench, CheckCircle2 } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";
import { fmtDate, fmtDateTime, money, PRICE_LABEL, deviceLabel } from "@/lib/auditDates";

export const rowHref = (r) => (r.is_primary ? `/orders/${r.order_id}` : `/orders/${r.order_id}/devices/${r.device_id}`);

const PriceLine = ({ r }) => (
  <div className="text-right" data-testid={`order-card-price-${r.order_number}-${r.device_index}`}>
    <div className="text-[10px] uppercase tracking-wide text-slate-400">{PRICE_LABEL[r.price_kind]}</div>
    {r.price != null && <div className={`font-heading font-extrabold text-lg ${r.price_kind === "final" ? "text-slate-900" : "text-slate-600"}`}>{money(r.price)}</div>}
  </div>
);

export const OrderRowCard = ({ r }) => (
  <Link to={rowHref(r)} className="card-interactive p-4 group flex flex-col gap-2" data-testid={`order-card-${r.order_number}${r.device_count > 1 ? `-${r.device_index}` : ""}`}>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 mb-1 flex-wrap">
          <span className="font-mono text-xs text-blue-600 tracking-wider">{r.order_number}</span>
          {r.device_count > 1 && <span className="text-[10px] font-semibold text-indigo-700 bg-indigo-50 border border-indigo-200 rounded-full px-2 py-0.5">Equipo #{r.device_index} de {r.device_count}</span>}
          <StatusBadge status={r.status} />
        </div>
        <div className="font-heading font-bold text-lg truncate group-hover:text-blue-700 transition-colors">{r.customer_name || "Cliente"}</div>
        <div className="text-sm text-slate-600 truncate">{deviceLabel(r) || r.category_name}</div>
      </div>
      <PriceLine r={r} />
    </div>
    <div className="text-sm text-slate-800 truncate" title={r.services}>
      <span className="text-slate-400 text-xs">Servicio: </span>{r.services || <span className="text-slate-400">Sin servicio cargado</span>}
    </div>
    {r.finalized_at && (
      <div className="flex items-center gap-1.5 text-xs font-semibold text-emerald-700" data-testid={`order-card-finalized-${r.order_number}-${r.device_index}`}>
        <CheckCircle2 size={14} /> Finalizada: {fmtDateTime(r.finalized_at)}
      </div>
    )}
    <div className="text-xs text-slate-400 truncate">Falla: {r.problem_reported || "—"}</div>
    <div className="flex items-center justify-between gap-2 text-xs text-slate-500 pt-2 border-t border-slate-200">
      <span className="truncate">{r.branch_name || "—"}</span>
      <span className="flex items-center gap-1 truncate font-medium text-slate-700"><Wrench size={12} />{r.technician_name || "Sin asignar"}</span>
      <span className="font-mono whitespace-nowrap">Rec. {fmtDate(r.received_at)}</span>
    </div>
  </Link>
);
